import { IconButton, ListItem, ListItemButton, ListItemText } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function MacroAutocompleteItem({ macro, index, activeIndex, onSelect, onHover, onView }) {
    if (!macro) return null
    const active = index === activeIndex
    const canView = typeof onView === "function"
    const label = macro.name ?? "Macro"

    return (
        <ListItem disablePadding>
            <ListItemButton
                data-cy="schedule-macro-option"
                selected={active}
                onClick={handleSelect}
                onMouseEnter={handleHover}
                sx={{
                    borderRadius: 1,
                    mx: 0.5,
                    my: 0.25,
                    alignItems: "flex-start",
                }}
            >
                <ListItemText primary={label} primaryTypographyProps={{ variant: "subtitle2" }} sx={{ mr: 1 }} />
                {canView && (
                    <IconButton
                        size="small"
                        onClick={handleView}
                        aria-label={`Preview ${label}`}
                        data-cy={`macro-autocomplete-preview-${macro.id}`}
                        sx={{ ml: "auto", alignSelf: "center" }}
                    >
                        <Iconify icon="mdi:eye" />
                    </IconButton>
                )}
            </ListItemButton>
        </ListItem>
    )

    function handleSelect() {
        if (typeof onSelect === "function") {
            onSelect(macro)
        }
    }

    function handleHover() {
        if (typeof onHover === "function") {
            onHover(index)
        }
    }

    function handleView(event) {
        event.stopPropagation()
        onView(macro)
    }
}
